import { render, staticRenderFns } from "./MilestonesForm.vue?vue&type=template&id=c84b1ac6&"
import script from "./MilestonesForm.vue?vue&type=script&lang=js&"
export * from "./MilestonesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports